import { Action } from '@ngrx/store';
import { IReport } from 'src/app/models/Report/Components/IReport';
import { IGenericError } from 'src/app/models/apiErrorDTOs/IGenericError';
import { DiscountReportParameters } from 'src/app/models/Report/ReportParameters/IDiscountReportParameters';
import { IReportDefinition } from 'src/app/models/Report/Components/IReportDefinition';
import { IReportPDFDefinition } from 'src/app/models/Report/Components/IReportPDFDefinition';
import { IReportSortDefinition } from 'src/app/models/Report/Components/IReportSortDefinition';
import { IReportXLSDefinition } from 'src/app/models/Report/Components/IReportXLSDefinition';

export enum DiscountReportActionTypes {
    LoadDiscountReport = '[Discount Report] Load Discount Report',
    LoadDiscountReportSuccessful = '[Discount Report] Load Discount Report - Successful',
    LoadDiscountReportFailed = '[Discount Report] Load Discount Report - Failed',
    ResetStore = '[Discount Report] Reset Store',
    SaveSearchParameters = '[Discount Report] Save Search Parameters',
    DownloadPDF = '[Discount Reports] Download Discount Reports',
    DownloadPDFSuccessful = '[Discount Reports] Download Discount Reports - Successful',
    DownloadPDFFailed = '[Discount Reports] Download Discount Reports - Failed',
    DownloadXLS = '[Void Reports] Download Discount Reports XLS',
    DownloadXLSSuccessful = '[Void Reports] Discount Void Reports XLS - Successful',
    DownloadXLSFailed = '[Void Reports] Discount Void Reports XLS - Failed',
    CleanUpFileBuffer = '[Discount Reports] Clean up file buffer'
}

export class LoadDiscountReport implements Action {
    readonly type = DiscountReportActionTypes.LoadDiscountReport;

    constructor(public payload: DiscountReportParameters) { }
}

export class LoadDiscountReportSuccessful implements Action {
    readonly type = DiscountReportActionTypes.LoadDiscountReportSuccessful;

    constructor(public payload: IReport) { }
}

export class LoadDiscountReportFailed implements Action {
    readonly type = DiscountReportActionTypes.LoadDiscountReportFailed;

    constructor(public payload: IGenericError) { }
}

export class ResetStore implements Action {
    readonly type = DiscountReportActionTypes.ResetStore;

    constructor() { }
}

export class SaveSearchParameters implements Action {
    readonly type = DiscountReportActionTypes.SaveSearchParameters;

    constructor(public payload: DiscountReportParameters) { }
}

export class DownloadPDF implements Action {
  readonly type = DiscountReportActionTypes.DownloadPDF;

  constructor(public definition: IReportDefinition, public pdfDefinition: IReportPDFDefinition, public sortDefinitions: IReportSortDefinition[]) { }
}

export class DownloadPDFSuccessful implements Action {
  readonly type = DiscountReportActionTypes.DownloadPDFSuccessful;

  constructor(public payload: ArrayBuffer) { }
}

export class DownloadPDFFailed implements Action {
  readonly type = DiscountReportActionTypes.DownloadPDFFailed;

  constructor(public payload: IGenericError) { }
}

export class DownloadXLS implements Action {
  readonly type = DiscountReportActionTypes.DownloadXLS;

  constructor(public definition: IReportDefinition, public xlsDefinition: IReportXLSDefinition, public sortDefinition: IReportSortDefinition[]) { }
}

export class DownloadXLSSuccessful implements Action {
  readonly type = DiscountReportActionTypes.DownloadXLSSuccessful;

  constructor(public payload: ArrayBuffer) { }
}

export class DownloadXLSFailed implements Action {
  readonly type = DiscountReportActionTypes.DownloadXLSFailed;

  constructor(public payload: IGenericError) { }
}

export class CleanUpFileBuffer implements Action {
  readonly type = DiscountReportActionTypes.CleanUpFileBuffer;

  constructor() { }
}

export type DiscountReportActions = LoadDiscountReport
    | LoadDiscountReportSuccessful
    | LoadDiscountReportFailed
    | ResetStore
    | SaveSearchParameters
    | DownloadPDF
    | DownloadPDFSuccessful
    | DownloadPDFFailed
    | DownloadXLS
    | DownloadXLSSuccessful
    | DownloadXLSFailed
    | CleanUpFileBuffer;
